import { DashboardFiltersPayload } from "../../services/dashboard.service";
import { ChartData } from "../../shared/types/common";
import { PerformanceComparisonMetric } from "../my-brand-screen/types";

export const PerformanceMetrics = [{ value: 'impressions', label: 'Impressions' }];
export const PerformanceByTimeColors = ['#DDEDF2', '#C7E0E9', '#8EC2D4', '#48889E', '#2B525F', '#112126'];

export type MyCompetitionPerformanceWidgetResponse = {
    myBrand: {
      brandKey:string,
      brandName?:string,
      dailyPerformance:ChartData[]
    };
    myCompetitors?: {
      brandKey:string,
      brandName?:string,
      dailyPerformance:ChartData[]
    }[],
    isUnderDateThreshold: boolean;
}

export interface MyCompetitionPerformanceByDeviceWidgetPayload extends DashboardFiltersPayload {
  brandKey: string,
  competitorKeys: string[]
}

export interface MyCompetitionPerformanceByTimeWidgetPayload extends DashboardFiltersPayload {
  brandKey: string,
  competitorKeys: string[],
  minImpressions?: number
}

export interface MyCompetitionPerformanceWidgetPayload extends DashboardFiltersPayload {
  brandKey: string,
  competitorKeys: string[],
  metric: string,
}

export interface MyCompetitionPerformanceMapWidgetPayload extends DashboardFiltersPayload {
  brandKey: string,
  competitorsKeys: string[],
  minImpressions?: number
}

export interface MyCompetitionWidgetPayload extends DashboardFiltersPayload {
  brandKey: string,
  competitorKeys?: string[],
  metric?: string,
  limit?: number,
}

export type MyCompetitionWidgetResponse = {
  brands: ChartData[];
}

export type MyCompetitionWordCloudResponse = {
  brands: {
    brandKey: string;
    brandName: string;
    logoPath?: string;
    words: {
      name: string;
      weight: number;
    }[];
  }[];
}

export type MyCompetitionBrandPerformanceByTime = {
  brandKey: string;
  brandName: string;
  [PerformanceComparisonMetric.ATTENTION]: (number|null)[];
  [PerformanceComparisonMetric.DWELL_TIME]: (number|null)[];
  [PerformanceComparisonMetric.AD_CLUTTER]: (number|null)[];
  [PerformanceComparisonMetric.AD_DENSITY]: (number|null)[];
  [PerformanceComparisonMetric.CPM]: (number|null)[];
  [PerformanceComparisonMetric.VIEWABILITY]: (number|null)[];
  [PerformanceComparisonMetric.IMPRESSIONS_SHARE]: (number|null)[];
}

export type MyCompetitionPerformanceByTimeWidgetResponse = {
  brands: MyCompetitionBrandPerformanceByTime[];
  isUnderDateThreshold: boolean;
}

export type MyCompetitionPerformanceByDeviceWidgetResponse = {
  brands: BrandPerformanceByDevice[];
  isInDeviceBreakdown: boolean;
}

export interface BrandPerformanceByDevice {
  brandKey: string;
  brandName: string;
  devices: DevicePerformance[];
}

export interface DevicePerformance {
  deviceType: DeviceType;
  [PerformanceComparisonMetric.ATTENTION]: number;
  [PerformanceComparisonMetric.DWELL_TIME]: number;
  [PerformanceComparisonMetric.AD_CLUTTER]: number;
  [PerformanceComparisonMetric.CPM]: number;
  [PerformanceComparisonMetric.VIEWABILITY]: number;
}

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  TABLET = 'tablet'
}


export interface MyCompetitionOverviewMetrics {
  viewability: number;
  attention: number;
  clutter: number;
  impressions: number;
  cpm: number;
  dwellTime: number;
}

export interface MyCompetitionOverviewData extends MyCompetitionOverviewMetrics {
  key: string;
  name: string;
}

export interface MyCompetitionOverviewResponse {
  brands: MyCompetitionOverviewData[];
  diff: MyCompetitionOverviewMetrics;
}

export interface SpendEfficiencyOverviewResponse {
  efficiencyDiff: number;
  impactDiff: number;
  attentionRank: number;
  brands: {
    brandKey: string;
    brandName: string;
    efficiency: number;
    impact: number;
    attention: number;
    impressions: number;
  }[];
}

export interface SpendEfficiencyDataPoint {
  brandKey: string;
  brandName: string;
  brandLogo: string;
  values: { metric: string; value: number }[];
}

export interface SpendEfficiencyResponse {
  brands: SpendEfficiencyDataPoint[];
}

export interface ContentCategoryDistributionPayload extends DashboardFiltersPayload {
    brandKey: string;
    competitorsKeys: string[];
}

export interface MyCompetitionShareOfVoiceWidgetPayload extends DashboardFiltersPayload {
  brandKey: string;
  competitorKeys: string[];
  categories?: string[];
}

export interface MyCompetitionAudienceGenderPayload extends DashboardFiltersPayload {
  brandKey: string;
  competitorKeys: string[];
}

export type MyCompetitionAudienceGenderBrand = {
  brandKey: string;
  brandName: string;
  menPercentage: number | null;
  womenPercentage: number | null;
};

export type MyCompetitionAudienceGenderResponse = {
  brands: MyCompetitionAudienceGenderBrand[];
};

export enum IABTier1Category {
  Attractions = "Attractions",
  Automotive = "Automotive",
  BooksAndLiterature = "Books and Literature",
  BusinessAndFinance = "Business and Finance",
  Careers = "Careers",
  Communication = "Communication",
  Crime = "Crime",
  Disasters = "Disasters",
  Education = "Education",
  Entertainment = "Entertainment",
  Events = "Events",
  FamilyAndRelationships = "Family and Relationships",
  FineArt = "Fine Art",
  FoodAndDrink = "Food & Drink",
  Genres = "Genres",
  HealthyLiving = "Healthy Living",
  HobbiesAndInterests = "Hobbies & Interests",
  Holidays = "Holidays",
  HomeAndGarden = "Home & Garden",
  Law = "Law",
  MedicalHealth = "Medical Health",
  PersonalCelebrationsAndLifeEvents = "Personal Celebrations & Life Events",
  PersonalFinance = "Personal Finance",
  Pets = "Pets",
  Politics = "Politics",
  PopCulture = "Pop Culture",
  RealEstate = "Real Estate",
  ReligionAndSpirituality = "Religion & Spirituality",
  Science = "Science",
  SensitiveTopics = "Sensitive Topics",
  Shopping = "Shopping",
  Sports = "Sports",
  StyleAndFashion = "Style & Fashion",
  TechnologyAndComputing = "Technology & Computing",
  Travel = "Travel",
  VideoGaming = "Video Gaming",
  WarAndConflicts = "War and Conflicts"
}
